import React, { Component } from 'react';
import {
    SimpleForm, TextInput, SelectInput, Edit, Toolbar,
    NumberInput, DeleteButton
} from 'react-admin';
import GetTaskButton from './Buttons/GetTask';
import {
    CodStatoUsoChoices, Statuses, ReverseChoices,
    Anomalie, CausaliChoices, Status_Regman
} from '../objects';
import ValidateAndSaveButton from './Buttons/ValidateAndSave';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';

const DeviceTitle = ({ record }) => {
    return <span>*ADMINISTRATOR*  Apparato {record ? `${record.serial_number_tim}` : ''}</span>;
};

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const DeviceToolbar = ({ permissions, scope, ...props }) => {
    return <Toolbar {...props} classes={useStyles()}>
        <ValidateAndSaveButton
            disabled={false}
            label="Salva"
            redirect="list"
            submitOnEnter={false}
            variant="flat"
        />
        <DeleteButton
            label="Delete" 
            undoable={false}/>
    </Toolbar>
};

class DeviceEdit_Admin extends Component {
    render() {
        return (
            <Edit title={<DeviceTitle />} aside={<Aside />} undoable={false} >
                <SimpleForm toolbar={<DeviceToolbar permissions={this.props.permissions} scope={this} />} validate={validateDevice}>
                    <SelectInput source="status.codice" label='Stato' choices={Statuses} />
                    <SelectInput source="anomalia.codice" label="Anomalia" choices={Anomalie} />
                    <TextInput source="serial_number_tim"  />
                    <TextInput source="serial_number_forn"  />
                    <TextInput source="mac_address"  />
                    <TextInput source="externalrefid" />
                    <NumberInput source="workrequestid" formClassName={this.props.classes.inlineBlock}/>
                    <GetTaskButton formClassName={this.props.classes.inlineBlock} />
                    <TextInput source="impianto" />
                    <TextInput source="codice_impresa_name" />
                    <TextInput source="tipo_task" />
                    <TextInput source="wr_prodotti" />
                    <TextInput source="cod_proj" />
                    <TextInput source="client_type" />
                    <TextInput source="resource_id" />
                    <TextInput source="data_completamento_wr" />
                    <TextInput source="check_NMU" />
                    <TextInput source="descrizione_impresa" />
                    <TextInput source="lista_NMU" />
                    <TextInput source="cod_terr_sap" />
                    <TextInput source="num_consegna" />
                    <TextInput source="impianto_regman" />
                    <TextInput source="install_regman_at" />
                    <TextInput source="cod_terr_sap_mos" />
                    <TextInput source="codice_magazzino" />
                    <TextInput source="divisione" />
                    <TextInput source="cod_nmu" />
                    <SelectInput source="status_regman.codice" label='Status Regman' choices={Status_Regman} />
                    <TextInput source="associated_at" />
                    <TextInput source="associated_by" />
                    <TextInput source="approved_at" />
                    <TextInput source="approved_by" />
                    <TextInput source="validated_at" />
                    <TextInput source="validated_by" />
                    <TextInput source="sent_to_sap" />
                    <SelectInput source="cod_stato_uso.codice" choices={CodStatoUsoChoices} />
                    <SelectInput source="reverse.codice" choices={ReverseChoices}  />
                    <SelectInput source="causale.codice" label="Causale" choices={CausaliChoices} />
                </SimpleForm>
            </Edit>
        );
    }
}

const Aside = () => (
    <div style={{ width: 300, margin: '1em' }}>
        <Typography variant="h6">Administrator Warning!</Typography>
        <div style={{ margin: '10px 0' }}></div>
        <Typography variant="body2">
            SAVE - no validations are performed, make sure you know what you are updating.
        </Typography>
    </div>
);


const validateDevice = (values, props) => {
    const errors = {};

    if (values.workrequestid) {
        //clear fields if the workrequestid changed manually
        var extRef = document.getElementById('workrequestid');

        if (extRef && extRef.dataset.gettaskres && extRef.dataset.gettaskres !== extRef.value) {
            extRef.dataset.gettaskres = "";
            clearInputValue(document.getElementById('impianto'), '');
            clearInputValue(document.getElementById('codice_impresa_name'), '');
            clearInputValue(document.getElementById('tipo_task'), '');
            clearInputValue(document.getElementById('wr_prodotti'), '');
            clearInputValue(document.getElementById('cod_proj'), '');
            clearInputValue(document.getElementById('client_type'), '');
            clearInputValue(document.getElementById('resource_id'), '');
            clearInputValue(document.getElementById('equivalenza_prod_applicabile'), '');
        }
    }

    if (!values.codice_impresa_name && values.status && values.status.codice !== '0') {
        errors.codice_impresa_name = [props.translate('tim.devices.sn_search_mandatory_2')];
    }

    return errors
};

function clearInputValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else {
        valueSetter.call(element, value);
    }
    element.dispatchEvent(new Event('input', { bubbles: true }));
};

export default DeviceEdit_Admin;